



















































































































































































































import {
  SfButton,
  SfLink,
  SfLoader,
} from '~/components';

import {
  defineComponent,
  onMounted,
  ref,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductLanding',
  components: {
    SfLink,
    SfLoader,
    SfButton,
    Carousel: () => import('~/components/togas/Carousel.vue'),
  },

  emits: ['scroll-to-top'],
  setup(__, { emit }) {

    const carouselClass = 'my-custom-carousel';
    const banners = ref([]);

    const sharedBreakpointSettings = {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 0,
    };

    const carouselSettings = {
      loop: true,
      breakpoints: {
        1400: sharedBreakpointSettings,
        1200: sharedBreakpointSettings,
        1024: sharedBreakpointSettings,
        768: sharedBreakpointSettings,
        480: sharedBreakpointSettings,
        0: sharedBreakpointSettings,
      }
    };

    const waitForElement = <T extends Element>(selector: string, timeout = 2000): Promise<T | null> => {
      return new Promise((resolve) => {
        const element = document.querySelector<T>(selector);
        if (element) {
          return resolve(element);
        }

        const observer = new MutationObserver(() => {
          const el = document.querySelector<T>(selector);
          if (el) {
            observer.disconnect();
            resolve(el);
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });

        setTimeout(() => {
          observer.disconnect();
          resolve(null);
        }, timeout);
      });
    };

    onMounted(async () => {
      const heading = await waitForElement<HTMLHeadingElement>('h1.product__name');
      const targetSpan = document.querySelector<HTMLSpanElement>('span.item-name');

      if (heading && targetSpan) {
        targetSpan.textContent = heading.textContent?.trim() || '';
      }
    });

    const isLoading = ref(false);

    const addButtonToPanel = async () => {
      isLoading.value = true;

      await new Promise((resolve) => setTimeout(resolve, 2000));

      const addToCartButton = document.querySelector('.product__add-to-cart-wrapper button') as HTMLButtonElement | null;

      if (addToCartButton && !addToCartButton.disabled) {
        addToCartButton.click();
      }

      isLoading.value = false;
    };

    function handleScroll() {
      if (window.innerWidth < 1024) return;

      const topPanel = document.querySelector('.top-panel') as HTMLElement | null;
      const headerTopWrapper = document.querySelector('.sf-header__top-wrapper') as HTMLElement | null;

      if (!topPanel || !headerTopWrapper) return;

      const top = topPanel.getBoundingClientRect().top;

      if (top <= 0) {
        headerTopWrapper.style.position = 'absolute';
      } else {
        headerTopWrapper.style.position = '';
      }
    }


    function animateImages(selectors: string[]) {
      let lastScrollY = window.scrollY;
      let scrollDirection: 'up' | 'down' = 'down';
      let hasAnimatedThisScroll = new Map<string, boolean>();

      selectors.forEach(selector => {
        const section = document.querySelector(selector);
        const images = section?.querySelectorAll<HTMLElement>('.image-animate');

        if (!section || !images?.length) return;

        hasAnimatedThisScroll.set(selector, false);

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              const isVisible = entry.intersectionRatio >= 0.8;

              if (scrollDirection === 'down' && isVisible && !hasAnimatedThisScroll.get(selector)) {
                images.forEach(image => image.classList.add('image-visible'));
                hasAnimatedThisScroll.set(selector, true);
              }

              if (scrollDirection === 'up' && !isVisible && hasAnimatedThisScroll.get(selector)) {
                images.forEach(image => image.classList.remove('image-visible'));
                hasAnimatedThisScroll.set(selector, false);
              }
            });
          },
          {
            threshold: 0.8,
          }
        );

        observer.observe(section);
      });

      window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        scrollDirection = currentScrollY < lastScrollY ? 'up' : 'down';
        lastScrollY = currentScrollY;
      }, { passive: true });
    }


    //

    onMounted(() => {
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();

      animateImages(['.section-rare', '.section-pattern']);
    });

    const handleScrollTop = () => {
      emit('scroll-to-top');
    };

    const showOnEntry = (entry) => {
      entry.forEach(change => {
        if (change.isIntersecting) {
          if (change.target.classList.contains('advent')) {
            change.target.classList.add('advent-animation');
          } else {
            change.target.classList.add('animation-show');
          }
        }
      });
    };

    onMounted(() => {
      let options = { threshold: [0.1] };
      let observer = new IntersectionObserver(showOnEntry, options);
      let elements = document.querySelectorAll('.advent, .animation');
      elements.forEach(elm => {
        observer.observe(elm);
      });
    });

    return {
      banners,
      isLoading,
      carouselClass,
      carouselSettings,
      handleScrollTop,
      waitForElement,
      addButtonToPanel,
      animateImages
    };
  },
});
